__turbopack_context__.v({
  "avatar": "HostImage-module-scss-module__bNAXWa__avatar",
});
